/*******************************************************************************************************************
 * File: /assets/js/newsletter.js
 * This takes into account SIMPLE sendy form integration. More complex coordinated versions can and will be done in the future
 * This is limited by the Sendy auto redirect set-up. 
 * To create double-opt-in simply set the Sendy list in question to double-opt-in. 
 * It will then use the "Subscribed" page. Single opt-in uses "Subscribe"
 * Author: ABLE DEv 
 *******************************************************************************************************************/

// /more-info-professionals/ has a form with a dropdown with the option: 'other (specify)' this function allows expected UI behaviour
export function subscriptionPage() {

  // Checking if URL has search query
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // This test for subscribe and then puts in email
  if (urlParams.has('email')) {
    
    const query = urlParams.get('email');   
    var newsletterEmail = query.trim();

    var target = document.querySelector("#enter-email-here");
    target.innerHTML = newsletterEmail;
  };
};